import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideAppInitializer, inject } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';

// Routes
import { routes } from './app.routes';

// Interceptors
import { HttpErrorService } from '@core/services/http-error.service';
import { httpErrorInterceptor } from '@core/interceptors/http-error.interceptor';
import { csrfInterceptor } from '@core/interceptors/csrf.interceptor';
import { backendErrorInterceptor } from '@core/interceptors/backend-error.interceptor';

// PrimeNG
import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

// ngx-translate
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { DicTranslateLoader } from '@core/loaders/dic-translate-loader';

// ----- Theme

const Preset = definePreset(Aura, {
	semantic: {
		primary: {
			50: '{blue.50}',
			100: '{blue.100}',
			200: '{blue.200}',
			300: '{blue.300}',
			400: '{blue.400}',
			500: '{blue.500}',
			600: '{blue.600}',
			700: '{blue.700}',
			800: '{blue.800}',
			900: '{blue.900}',
			950: '{blue.950}',
		},
	},
});

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideRouter(
			routes,
			withNavigationErrorHandler(() => inject(HttpErrorService).report('screen')),
		),
		provideHttpClient(withInterceptors([httpErrorInterceptor, csrfInterceptor, backendErrorInterceptor])),
		providePrimeNG({
			theme: {
				preset: Preset,
				options: {
					darkModeSelector: false || 'none',
				},
			},
		}),
		MessageService,
		ConfirmationService,
		provideTranslateService({
			fallbackLang: window.appConfig.application.language,
			loader: { provide: TranslateLoader, useClass: DicTranslateLoader },
		}),
		provideAppInitializer(() => {
			inject(TranslateService).use(window.appConfig.application.language);
		}),
	],
};
